export const imprint = {
  lastUpdated: '26. Januar 2026',
  lastUpdatedLabel: 'Zuletzt aktualisiert',
  
  meta: {
    title: 'Impressum',
    description: 'Impressum für TerminTeiler - Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)'
  },
  
  content: {
    title: 'Impressum',
    ddg: 'Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)',
    
    description: `
      <p><strong>TerminTeiler</strong><br/>
      Digitale Plattform zur freiwilligen Weitergabe von Arztterminen<br/>
      (Projekt in der Gründungs- und Testphase / MVP)</p>
    `,
    
    provider: {
      title: 'Anbieterin / Verantwortliche:',
      name: 'Feryal Catoglu'
    },
    
    address: {
      title: 'Anschrift (ladungsfähig):',
      name: 'TerminTeiler-Startpunkt57',
      street: 'Sandstraße 26',
      city: '57072 Siegen',
      country: 'Deutschland'
    },
    
    contact: {
      title: 'Kontakt:',
      email: 'E-Mail: support@terminteiler.com',
      phone: 'Telefon: +49 152 38556881'
    },
    
    contentResponsible: {
      title: 'Verantwortlich für den Inhalt nach § 18 Abs. 2 Medienstaatsvertrag (MStV)',
      name: 'Feryal Catoglu',
      note: '(Anschrift wie oben)'
    },
    
    coFounders: {
      title: 'Mitgründer / Team:',
      members: [
        {
          name: 'Feryal Catoglu',
          role: 'Gründerin & Visionärin'
        },
        {
          name: 'Faheem Babar',
          role: 'Mitgründer & Projektmanager'
        },
        {
          name: 'Haitham El Euch',
          role: 'Mitgründer & Softwareentwickler'
        },
        {
          name: 'Jouhaina Salsabil El Euch',
          role: 'Mitgründerin & Softwareentwicklerin'
        }
      ]
    },
    
    partner: {
      title: 'Kooperationspartner',
      organizationName: 'TerminTeiler-Startpunkt57 – Die Initiative für Gründer e. V.',
      street: 'Sandstraße 26',
      city: '57072 Siegen',
      country: 'Deutschland'
    },
    
    projectStatus: {
      title: 'Projektstatus / Hinweis',
      content: `
        <p>TerminTeiler befindet sich derzeit in einer nicht-kommerziellen Test- und Pilotphase (MVP).</p>
        <p>Die Plattform dient ausschließlich der technischen Erprobung, internen Tests sowie dem Nutzerfeedback.</p>
        <p>Es findet keine medizinische Beratung, keine rechtsverbindliche Terminvermittlung und keine Zusammenarbeit mit Arztpraxen statt.</p>
      `
    },
    
    liabilityContent: {
      title: 'Haftung für Inhalte',
      content: `
        <p>Als Diensteanbieterin bin ich gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.</p>
        <p>Nach §§ 8 bis 10 DDG bin ich jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.</p>
        <p>Eine Haftung für die Richtigkeit, Vollständigkeit oder Aktualität der bereitgestellten Inhalte wird nicht übernommen.</p>
      `
    },
    
    liabilityLinks: {
      title: 'Haftung für externe Links',
      content: `
        <p>Diese Website enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte ich keinen Einfluss habe.</p>
        <p>Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.</p>
        <p>Bei Bekanntwerden von Rechtsverletzungen werden derartige Links unverzüglich entfernt.</p>
      `
    },
    
    copyright: {
      title: 'Urheberrecht',
      content: `
        <p>Die Inhalte dieser Website unterliegen dem deutschen Urheberrecht.</p>
        <p>Eine Nutzung außerhalb der gesetzlichen Grenzen bedarf der vorherigen schriftlichen Zustimmung.</p>
      `
    },
    
    disputeResolution: {
      title: 'Online-Streitbeilegung',
      content: `
        <p>Plattform der EU-Kommission:<br/>
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a></p>
        <p>Ich bin nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren teilzunehmen.</p>
      `
    }
  }
};

